<template>
    <div class="mt-4 pt-4">
     <h3><strong>Report</strong></h3>
        <div class="">
            <div class="row">
                <div class="col-md-12">
                    <div class="card strpied-tabled-with-hover">
                        <div class="card-body">
                          <div class="row mb-4">
                            <div class="col-md-2">
                              <select v-model="selection" class="mb-3 ml-2 form-select">
                                <option value="draft">Draft</option>
                                <option
                                  v-if="isSuperAdmin || isPentester || (project.status == 2 && project.payment_status == 2)"
                                  value="completed"
                                  >Completed</option>
                                <option
                                  v-if="isSuperAdmin || isPentester || (project.status == 2 && project.payment_status == 2)"
                                  value="noresolved">Exclude resolved</option>
                              </select>
                            </div>
                            <div class="col-md-8 text-start">
                              <button
                                v-if="isSuperAdmin || isPentester || project.status == 2"
                                type="button"
                                class="btn btn-warning me-2"
                                v-on:click="print('draft')" title="Export draft ">
                                <i class="fa fa-download"></i>
                              </button>
                              <button
                                v-if="isSuperAdmin || isPentester || (project.status == 2 && project.payment_status == 2)"
                                type="button"
                                class="btn btn-success me-2"
                                v-on:click="print('complete')"
                                title="Export complete">
                                <i class="fa fa-download"></i>
                              </button>
                              <button
                                v-if="isSuperAdmin || isPentester || (project.status == 2 && project.payment_status == 2)"
                                type="button"
                                class="btn btn-info text-light me-2"
                                v-on:click="print('noresolved')"
                                title="Export w/out resolved">
                                <i class="fa fa-download"></i>
                              </button>
                            </div>
                            <div class="col text-end" v-if="isSuperAdmin || isPentester">
                              <button class="btn btn-outline-info text-dark" data-bs-toggle="modal" data-bs-target="#sendReportViaEmail">Send report via email</button>
                            </div>
                          </div>
                            <div v-if="loading">
                              <div class="spinner-border spinner-border-sm me-2" role="status">
                                <span class="visually-hidden">Loading...</span>
                              </div>
                              Loading..
                            </div>
                            <div>
                              <div>
                                <pdf
                                  @loaded="onPdfLoaded"
                                  class="m-auto"
                                  v-for="i in numPages"
                                  :key="i"
                                  :src="src"
                                  :page="i"
                                  dpi="50"
                                  style="width:65%"
                                ></pdf>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal fade" id="sendReportViaEmail" tabindex="-1"  aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h3>Send report via email</h3>
                <button type="button" class="btn-close" id="closeEmailPopups" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <email v-on:callback="mailingCallback"/>
              </div>
            </div>
          </div>
        </div>


    </div>
</template>
<script>
  import pdf from 'vue-pdf'
  import { mapGetters } from 'vuex'
  import email from './Email.vue'
  export default {
    components: {
      pdf,
      email
    },
    data () {
      return {
        src: null,
        numPages: undefined,
        active: 0,
        project_id : this.$route.params.prod_id,
        org_id : this.$route.params.org_id,
        selection: 'draft',
        downloadBlob: null,
        project: null,

        loading: true,
        progress: 0,
      }
    },
    async mounted() {
      this.loadPdf();
      this.getProject(this.org_id, this.project_id);
    },
    computed: {
      ...mapGetters({
        isSuperAdmin: 'auth/isSuperAdmin',
        isPentester: 'auth/isPentester'
      })
    },
    watch: {
      selection : function() {
        this.loadPdf();
      }
    },
    methods: {
      async loadPdf() {
        this.loading = true;
        let url = "";
        if (this.selection == "noresolved") {
          url = this.$server + 'organisation/'+ this.org_id +'/project/' + this.project_id + '/reports/pdf?type=noresolved';
        } else if(this.selection == "draft") {
          url = this.$server + 'organisation/'+ this.org_id +'/project/' + this.project_id + '/reports/pdf?type=draft';
        } else {
          url = this.$server + 'organisation/'+ this.org_id +'/project/' + this.project_id + '/reports/pdf';
        }

        const accessToken = this.$store.state.auth.accessToken;
        this.src = pdf.createLoadingTask({
            url: url,
            httpHeaders: {
              'Authorization' : `Bearer ${accessToken}`
            }
        });
        this.src.promise.then(pdf => {
          this.numPages = pdf.numPages;
        });
      },
      // Called when PDF is fully loaded
      onPdfLoaded() {
        this.loading = false;
      },

      getProject(org_id, prod_id) {
        const me = this;
        this.$axios
        .get(this.$server + 'organisation/'+ org_id +'/project/' + prod_id)
        .then(res => {
          var r = res.data;
          if (r.success) {
              me.project = r.data[0];
          }

        });
      },
      print(isWatermark) {
        if (document.getElementById("pdfDownload") != null) {
          document.getElementById("pdfDownload").remove();
        }
        const d = new Date();
        var abbr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var org = JSON.parse(localStorage.getItem("organisation"));
        var pdfTitle = abbr[d.getMonth()] + "" + d.getFullYear() + "_" + org.name + "_" + localStorage.getItem("project") + ".pdf";

          var url = this.$server + 'organisation/'+ this.org_id +'/project/' + this.project_id + '/reports/pdf?download=true';

          if (isWatermark == "draft") {
              url = this.$server + 'organisation/'+ this.org_id +'/project/' + this.project_id + '/reports/pdf?type=draft&download=true';
          } else if (isWatermark == "noresolved") {
              url = this.$server + 'organisation/'+ this.org_id +'/project/' + this.project_id + '/reports/pdf?type=noresolved&download=true';
          }

          this.$axios.get(url, {
              responseType: 'blob',
              crossDomain: true
          }).then((response) => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', this.getFilename(response.headers['content-disposition']));
            document.body.appendChild(link);
            link.click();
          });
      },
      getFilename(contentDisposition) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches != null && matches[1]) {
          return matches[1].replace(/['"]/g, '');
        }
        return null;
      },

      mailingCallback(res) {
        if (res) { // accept any value from callback
          document.getElementById("closeEmailPopups").click();
        }
      }

    }
  }
</script>